import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'

bootstrapApplication(AppComponent, appConfig)
    .then(() => console.info('✅ Angular Bootstrap Success!'))
    .catch((err) => console.error('❌ Angular Bootstrap Error:', err))
